import { ref } from 'vue';
import { defineStore } from 'pinia';
import {
  getV7PermissionsGroupRoles,
  getV7PermissionsGroupRolesAuthSetting,
  getV7PermissionsGroupRolesAuth,
} from '@/api-client/userAndPermission/queries/permission-controller/permission-controller';
import { RoleGroupRolePermissionItems } from '@/api-client/userAndPermission/model';
import { FRAME_NAMES } from '@/common/define/apiTrace.define';
import { useRolePermission } from '@/common/permission/permission.utils';

export const useRolePermissionStore = defineStore('rolePermission', () => {
  const globalPermissionList = ref<RoleGroupRolePermissionItems>();

  const getUserRoleList = async (rolePermissionId?: string) => {
    try {
      const {
        data: { data = [] },
      } = await getV7PermissionsGroupRoles(
        {
          rolePermissionId,
        },
        {
          frameName: FRAME_NAMES.CONFIG_ROLE_PERMISSION.USER_ROLE_LIST,
        },
      );

      return data;
    } catch (error) {
      console.log(error);
    }

    return [];
  };

  const getPermissionList = async (rolePermissionId: string) => {
    try {
      const {
        data: { data = [] },
      } = await getV7PermissionsGroupRolesAuthSetting(
        {
          rolePermissionId,
        },
        {
          frameName: FRAME_NAMES.CONFIG_ROLE_PERMISSION.PERMISSION_LIST,
        },
      );

      return data[0] || {};
    } catch (error) {
      console.log(error);
    }

    return {};
  };

  const getGlobalPermissionList = async (rolePermissionId: string) => {
    try {
      const {
        data: { data = [] },
      } = await getV7PermissionsGroupRolesAuth(
        {
          rolePermissionId,
        },
        {
          frameName: FRAME_NAMES.CONFIG_ROLE_PERMISSION.GLOBAL_PERMISSION_LIST,
        },
      );

      return data[0] || {};
    } catch (error) {
      console.log(error);
    }

    return {};
  };

  const setGlobalPermissionList = async (rolePermissionId: string) => {
    globalPermissionList.value = await getGlobalPermissionList(rolePermissionId);
  };

  const { isPermissionDenied } = useRolePermission();

  return {
    globalPermissionList,
    getUserRoleList,
    getPermissionList,
    setGlobalPermissionList,
    isPermissionDenied,
  };
});
